/**
 * Utility to construct full image URLs from relative paths.
 * Uses localhost for development, production API otherwise.
 */
export const getFullImageUrl = (imagePath: string): string => {
  if (!imagePath) return '';
  console.log('Image path:', imagePath);
  
  const baseUrl = 'https://api.hotelbuzz.ch';

  if(imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath; // Already a full URL
    } 

  
  // Ensure path starts with /
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  
  return `${baseUrl}${normalizedPath}`;
};